
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },

    name: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: 'auswählen',
    },

    value: {
      type: [String, Object],
      default: null,
    },

    rules: {
      type: [String, Object],
      default: '',
    },

    bgColor: {
      type: String,
      default: 'gray',
    },

    validationMode: {
      type: String,
      default: 'aggressive',
    },

    bold: {
      type: Boolean,
      default: false,
    },

    instructions: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      innerValue: this.value,
    }
  },

  watch: {
    innerValue() {
      this.$emit('input', this.innerValue)
    },

    value() {
      this.innerValue = this.value
    },
  },
}
